import React, { useEffect } from "react";
import './Blog.css';


const Blog_Registration = () => {

    const points = [
      "Managing staff and care delivery",
      "Maintaining CQC compliance",
      "Safeguarding vulnerable people ",
      "Handling audits, policies, and procedures ",
      "Leading inspections and quality improvement ",
      "Ensuring safe, effective, and person-centred care",
    ]
  const points2 = [
    "Care homes",
    "Domiciliary care services",
    "Supported living services",
    "Specialist healthcare services",
    "Nursing services",
    "Community care organisations",
  ];

  const points3 = [
    "DBS Certificate",
    "Proof of ID",
    "Employment history & CV",
    "Professional references",
    "Health declaration",
    "Care qualifications (Level 5 or equivalent)",
    "Safeguarding & compliance training",
  ];

  const points4 = [
    "Documents are missing",
    "Employment history is unclear",
    "Policies are incomplete",
    "Interview preparation is poor",
  ];

  const points5 = [
    "Online application submission",
    "Initial CQC review",
    "Fit Person assessment",
    "CQC interview",
    "Final registration decision",
  ];

  const points6 = [
    "Safeguarding",
    "Safe care delivery",
    "Staffing & leadership",
    "Incident reporting",
    "Governance systems",
    "CQC Key Lines of Enquiry (KLOEs)",
    "Compliance responsibilities",
  ];

  const points7 = [
    "How would you manage a safeguarding concern?",
    "How do you ensure safe staffing levels?",
    "What would you do if medication errors occurred?",
    "How do you maintain compliance standards?",
  ];

  const points8 = [
    "CQC Registration Support",
    "Registered Manager Applications",
    "Mock CQC Interviews",
    "Care Policies & Procedures",
    "Compliance Audits",
    "New Care Business Setup",
    "CQC Improvement Plans",
    "Governance & Quality Assurance",
  ];


  // open page on top //
 useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // open page on top // 

  return (
     <>
       <section className="cqc-update-section">
      <div className="cqc-update-container">
        <h2 className="cqc-update-title">CQC Registration for Managers: Everything You Need to Know</h2>
      </div>
    </section>
    <section className="Blog-section">
      <div className="Blog-container">
         <div className='Blog-Cue'>
          <p>Becoming a CQC Registered Manager is a major step in the care sector. Whether you run a care home, domiciliary care agency, 
            supported living service, or healthcare business, registering with the Care Quality Commission is a legal requirement for many
             regulated activities.</p>
             <p>The process can feel overwhelming — but with the right support, it doesn’t have to be.<br/>
              At Total Care Advisory, we help care providers and managers complete successful CQC applications quickly, correctly, and
              with minimal stress. </p>
          <h3 className='Blog-title'></h3>
         </div>
         <div className='Blog-Cue'>
          <h3 className='Blog-title'>What Is a CQC Registered Manager?</h3>
          <p>A Registered Manager is responsible for the day-to-day running of a regulated care service and ensuring compliance with CQC standards.</p>
          <p>This includes:</p>
           <div className="bullet-container">
            <ul className="bullet-list">
              {points.map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
          </div>
          <p>If you are managing regulated activities, you will usually need to complete a CQC Registration for Managers application.</p>
         </div>
          <div className='Blog-Cue'>
          <h3 className='Blog-title'>Who Needs CQC Registration?</h3>
          <p>You typically need to register with the CQC if you manage:</p>
           <div className="bullet-container">
            <ul className="bullet-list">
              {points2.map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
          </div>
          <p>Even experienced care managers moving to a new provider must submit a fresh application.</p>
         </div>
         <div className='Blog-Cue'>
          <h3 className='Blog-title'>Common Documents Needed for CQC Registration</h3>
          <p>Preparing correctly can significantly reduce delays.</p>
          <p>Most Registered Manager applications require:</p>
           <div className="bullet-container">
            <ul className="bullet-list">
              {points3.map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
          </div>
          <p>Many applications are delayed because of incomplete paperwork or weak supporting evidence.</p>
          <p>At Total Care Advisory, we review your full application before submission to improve approval chances.</p>
         </div>
         <div className='Blog-Cue'>
          <h3 className='Blog-title'>How Long Does CQC Registration Take?</h3>
          <p>Most CQC manager applications take around 8–12 weeks, although delays are common if:</p>
           <div className="bullet-container">
            <ul className="bullet-list">
              {points4.map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
          </div>
          <p>The process usually includes:</p>
           <div className="bullet-container">
            <ul className="bullet-list">
              {points5.map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
          </div>
         </div>
         <div className='Blog-Cue'>
          <h3 className='Blog-title'>The CQC Registered Manager Interview</h3>
          <p>The CQC interview is one of the most important stages of the registration process.<br/>
          Inspectors will assess your knowledge of:
          </p>
           <div className="bullet-container">
            <ul className="bullet-list">
              {points6.map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
          </div>
          <p>Typical questions include:</p>
          <div className="bullet-container">
            <ul className="bullet-list">
              {points7.map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
          </div>
          <p>Preparing properly can dramatically improve your confidence and success rate.</p>
                    <h3 className='Blog-title'>CQC Registration for Managers</h3>
         </div>
         <div className='Blog-Cue'>
           <h3 className='Blog-title'>Why Care Providers Choose Total Care Advisory</h3>
          <p>At Total Care Advisory, we support care businesses across the UK with:</p>
           <div className="bullet-container">
            <ul className="bullet-list">
              {points7.map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
          </div>
          <p>Our team understands exactly what the CQC expects and helps you avoid costly mistakes and delays.</p>
         </div>
         <div className='Blog-Cue'>
          <h3 className='Blog-title'>Expert CQC Registration Support</h3>
          <p></p>
           <div className="bullet-container">
            <ul className="bullet-list">
              {points8.map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
          </div>
          <p>If you are applying to become a Registered Manager, starting a care business, or 
            struggling with a delayed application, professional guidance can save significant time 
            and stress.</p>
         </div>      
      </div>
      </section>
     
     
     </>
  )
}

export default Blog_Registration
